/**
 * 当前文章页的点赞/收藏/评论数，供左侧悬浮工具栏独立显示
 */
import React, { createContext, useContext, useState, useCallback } from 'react';

export interface PostStats {
  postId: string | null;
  likeCount: number;
  commentCount: number;
  isLiked: boolean;
  isBookmarked: boolean;
}

const defaultStats: PostStats = {
  postId: null,
  likeCount: 0,
  commentCount: 0,
  isLiked: false,
  isBookmarked: false,
};

type SetPostStats = (stats: Partial<PostStats> | ((prev: PostStats) => Partial<PostStats>)) => void;

interface PostStatsContextValue {
  postStats: PostStats;
  setPostStats: SetPostStats;
  clearPostStats: () => void;
}

const PostStatsContext = createContext<PostStatsContextValue | null>(null);

export function PostStatsProvider({ children }: { children: React.ReactNode }) {
  const [postStats, setPostStatsState] = useState<PostStats>(defaultStats);

  const setPostStats = useCallback<SetPostStats>((payload) => {
    setPostStatsState((prev) => {
      const next = typeof payload === 'function' ? payload(prev) : payload;
      return { ...prev, ...next };
    });
  }, []);

  const clearPostStats = useCallback(() => {
    setPostStatsState(defaultStats);
  }, []);

  return (
    <PostStatsContext.Provider value={{ postStats, setPostStats, clearPostStats }}>
      {children}
    </PostStatsContext.Provider>
  );
}

export function usePostStats() {
  const ctx = useContext(PostStatsContext);
  return ctx ?? { postStats: defaultStats, setPostStats: () => {}, clearPostStats: () => {} };
}
